import { Moon, Sun } from 'lucide-react';

import { Button } from '@/shared/ui/shadcn/button';
import { useTheme } from '@/app/providers/useTheme';

const THEME_ICONS = {
  light: Sun,
  dark: Moon,
} as const;

const THEME_LABELS = {
  light: 'Light mode',
  dark: 'Dark mode',
} as const;

/**
 * Toggle button for cycling through theme modes (light → dark → system).
 * Uses semantic tokens and shadcn Button component.
 */
export function ThemeToggle() {
  const { theme, setTheme } = useTheme();

  const handleToggle = () => {
    setTheme(theme === 'light' ? 'dark' : 'light');
  };

  const Icon = THEME_ICONS[theme];
  const label = THEME_LABELS[theme];

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={handleToggle}
      aria-label={`Current theme: ${label}. Click to change.`}
      title={label}
    >
      <Icon className="h-5 w-5" />
    </Button>
  );
}
